@if (enabled) {
  <button
    type="button"
    class="transparent-btn"
    (click)="openModal()"
    ngbTooltip="Sélectionner et importer l'offre signée"
    i18n-ngbTooltip
  >
    <app-arrow-right-icon height="16px" width="16px" color="var(--brand-500)" />
  </button>

  <app-action-modal
    #modal
    [disabled]="submitted"
    [submitDisabled]="!canSubmit"
    [showHeader]="true"
    [fullWidthFooter]="true"
    submitButtonClass="lty-btn-primary"
    size="lg"
    customModalClass="ngb-full-size-modal accept-offer-modal"
    headerIconState="normal"
    (cancelled)="resetForm()"
    (submitted)="acceptOffer()"
  >
    <div class="accept-offer-icon" headerIcon>
      <app-download-cloud-icon
        height="16px"
        width="16px"
        color="var(--text-tertiary-600)"
      />
    </div>

    <ng-container mainTitle i18n
      >Sélectionner et importer l'offre signée</ng-container
    >

    <div class="accept-offer-content" subtitle>
      <div
        class="row gy-4 justify-content-center row-cols-lg-3 accept-offer-proposals"
        [class.single-row-scroll-container]="proposals.length > 0"
      >
        @for (offer of proposals; track offer.proposalId) {
          <div class="col single-row-scroll-col">
            <app-proposal-displayer
              [class.accept-offer-proposal--selected]="
                isSelected(offer.proposalId)
              "
              [offer]="offer"
              [showViewIcon]="false"
              [showActions]="false"
              (viewDocument)="viewFile($event)"
            >
              <button
                type="button"
                class="lty-btn w-100 accept-offer-select-btn lty-btn-primary"
                [class.accept-offer-select-btn--selected]="
                  isSelected(offer.proposalId)
                "
                (click)="selectProposal(offer.proposalId)"
              >
                @if (isSelected(offer.proposalId)) {
                  <ng-container i18n>Sélectionné</ng-container>
                } @else {
                  <ng-container i18n>Sélectionner</ng-container>
                }
              </button>
            </app-proposal-displayer>
          </div>
        }
      </div>

      <form class="lty-form accept-offer-form">
        <p class="accept-offer-form__label" i18n>Offre signée</p>
        <div class="file alternate accept-offer-upload">
          <input
            type="file"
            id="accept-offer-file"
            class="file-input"
            accept=".pdf,.png,.jpg,.jpeg,.gif"
            (change)="onFileUpload($event)"
          />
          <div class="upload-icon">
            <app-upload-cloud-icon
              height="20px"
              width="20px"
              color="var(--gray-600)"
            />
          </div>
          <span>
            <span class="highlighted-text" i18n>Cliquer</span>
            <ng-container i18n> ou glisser déposer</ng-container>
          </span>
        </div>

        @if (uploadedFile) {
          <div class="mt-16">
            <span class="mb-16 file-label" i18n>Document téléchargé</span>
            <div class="uploaded-file-container">
              <div class="uploaded-file-element">
                <app-file-icon
                  height="20px"
                  width="20px"
                  color="var(--gray-400)"
                />
                <div class="file-name">
                  <span>{{ uploadedFile.name }}</span>
                  <span>{{ uploadedFile.size | fileSize: 1 }}</span>
                </div>
                <app-check-circle-icon
                  height="16px"
                  width="16px"
                  color="var(--success-500)"
                />
              </div>
              <app-trash-icon
                class="clickable"
                (click)="removeFile()"
                (keydown.enter)="removeFile()"
                (keydown.space)="removeFile()"
                tabindex="0"
                role="button"
                height="24px"
                width="24px"
                color="var(--gray-400)"
              />
            </div>
          </div>
        }

        <div class="form-group accept-offer-date">
          <label for="signatureDate" i18n>Date de signature de l'offre</label>
          <input
            id="signatureDate"
            type="date"
            class="form-control"
            name="signatureDate"
            [(ngModel)]="signatureDate"
          />
        </div>
      </form>
    </div>

    <ng-container submitButtonLabel i18n>Valider</ng-container>
  </app-action-modal>

  <app-pdf-viewer-modal #pdfViewer />
}
